import { Component, OnInit, OnDestroy, ViewChild, TemplateRef } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CoreConfigService } from '@core/services/config.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'environments/environment';
import { MaintenanceService } from '../../api/services/maintenance.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit, OnDestroy {

  @ViewChild('welcomeModal') welcomeModal!: TemplateRef<any>;
  
  public searchText: any;
  public data: any;
  public coreConfig: any;
  currentState = environment.currentState
  court_bg_path = environment.court_bg_path
  court_logo_path = environment.court_logo_path
  courtTitle = environment.courtTitleSentence;
  is_portal_mode_partial = localStorage.getItem('is_portal_mode_partial');
  
  // Time-based maintenance properties
  timeUntilMaintenance: string | null = null;
  timeUntilMaintenanceEnds: string | null = null;
  maintenanceMessage: string = '';
  
  // Day-based maintenance properties
  nextMaintenanceDay: string | null = null;
  currentMaintenanceDayStatus: string | null = null;

  refNoControl = new FormControl(null, [Validators.required]);
  docType = "";

  private _unsubscribeAll: Subject<any> = new Subject();

  constructor(
    private _coreConfigService: CoreConfigService,
    private modalService: NgbModal,
    private router: Router,
    private maintenanceService: MaintenanceService,
    ) {
    // Configure the layout
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true
        },
        menu: {
          hidden: true
        },
        footer: {
          hidden: false
        },
        customizer: false,
        enableLocalStorage: true
      }
    };
  }

  ngOnInit(): void {

      // Open welcome modal after a short delay
      setTimeout(() => {
        this.openWelcomeModal();
      }, 1000);
    

    this.maintenanceService.partialMaintenanceMode$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((isPartial) => {
        this.is_portal_mode_partial = isPartial ? 'true' : 'false';
      });

    // Subscribe to maintenance schedule for time-based information
    this.maintenanceService.maintenanceSchedule$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((schedule) => {
        if (schedule) {
          this.maintenanceMessage = schedule.message || 'Scheduled maintenance in progress. ';
        }
      });

    // Subscribe to countdown timers
    this.maintenanceService.getTimeUntilMaintenance()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((time) => {
        this.timeUntilMaintenance = time;
      });

    this.maintenanceService.getTimeUntilMaintenanceEnds()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((time) => {
        this.timeUntilMaintenanceEnds = time;
      });

    // Subscribe to day-based maintenance information
    this.maintenanceService.getNextMaintenanceDay()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((day) => {
        this.nextMaintenanceDay = day;
      });

    this.maintenanceService.getCurrentMaintenanceDayStatus()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((status) => {
        this.currentMaintenanceDayStatus = status;
      });
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  // In your component's class
  navigateToVerification() {

  const refNo = this.refNoControl.value;
  //  check for refNo
  if (!refNo) {
    return; // Stop further execution
    }
  this.router.navigate(['/auth/verify-affidavit', refNo]);
}

// modal Basic
  modalOpen(modalBasic) {
    this.modalService.open(modalBasic);
  }

  // modal Open Vertically Centered
  modalOpenVC(modalVC) {
    this.modalService.open(modalVC, {
      centered: true,
      size: 'lg'
    });
  }

  // modal Open Backdrop Disabled
  modalOpenBD(modalBD) {
    this.modalService.open(modalBD, {
      backdrop: false,
      centered: true
    });
  }

  // modal Open Animation Disabled
  modalOpenAD(modalAD) {
    this.modalService.open(modalAD, {
      centered: true,
      windowClass: 'animation-disable',
      animation: false
    });
  }
  
  // Welcome modal
  openWelcomeModal() {
    const modalRef = this.modalService.open(this.welcomeModal, {
      centered: true,
      size: 'lg',
      backdrop: 'static',
      keyboard: false,
      windowClass: 'welcome-modal'
    });
    
    // Mark that user has seen the welcome modal
   // sessionStorage.setItem('hasSeenWelcomeModal', 'true');
    
    // Handle modal close event
    modalRef.closed.subscribe(() => {
      // Modal was closed
    });
  }

  // Reset welcome modal state (for testing purposes)
  resetWelcomeModal() {
   // sessionStorage.removeItem('hasSeenWelcomeModal');
    this.openWelcomeModal();
  }

}
